
export const AppMessages =
{
	deleteActionText: 'Delete',
	deleteButtonText: 'Delete',
	dummyDate: "1/1/1970",
	addActionText: 'Add',
	addButtonText: 'Add',

	editActionText: 'Edit',
	editButtonText: 'Edit',

	notifications: 'Notifications',
	failedRegistrationFileName: 'BulkUserRegistrations',
	failedRegistrationSheetName: 'Bulk Registrations',

	// This meesage will be used in Alert dialog title, when the response successfull
	dialogSuccessTitle: 'Success',
	dialogErrorTitle: 'Error',
	dialogOkButtonText: 'OK',

	// This Message will be used when the User approval success
	userApprovalSuccess: 'Your user approval request has been processed successfully.',
	userRejectSuccess: 'Your user approval request has been rejected.',
	allUserApprovalSuccess: 'All User approval request has been processed successfully.',
	allUserRejectSuccess: 'All User approval request has been rejected.',
	userApprovalCEOValidationFailed: 'The Active CEO user for this organization currently is ',


	// Switch Organization
	switchOrgTitle: 'Switch Organization',
	switchOrgFailure: 'Unable to Switch Organization',
	switchOrgNone: 'User has no Active Secondary Organizations',

	// Application Management
	appManagementTitle: 'Application Management',
	deleteApplication: 'Delete Application',
	deleteAppSuccess: 'Application deleted Successfully',
	deleteAppFailure: 'Unable to Delete',
	deleteAppText: 'Are you sure you want to delete the Application',


	// Application Management Modal
	appCreationTitle: 'Application Management',
	memberProfileBirthDt: 'Please select Birth Date',
	memberProfileValidation: 'Please enter valid values for the mandatory fields to Save Member Profile',
	memberProfileInvalidMovDt: 'Please enter valid values for Date Entered Movement',
	appCreateValidation: 'Please enter all the mandatory fields to save Application',
	appCreateRoleValidation: 'Please add roles for the Application',
	appCreateLogoValidation: 'Please select the Application Logo',
	appCreateLogoSizeValidation: 'Only jpg/jpeg/png files are allowed',
	appCreateCodeValidation: 'Application Code already exists',
	appCreateNameValidation: 'Application Name already exists',
	appCreateAppOwnersExists: 'Please select Application Owner',
	appCreateRoleNameValidation: 'Please enter Role Name',
	appCreateRoleNameDuplicationValidation: 'Application Role Name already exists',
	appCreateRoleDescValidation: 'Please enter Role Description',

	updateAppSuccess: 'Application has been updated Successfully',
	updateAppFailure: 'Unable to update Application',

	addAppSuccess: 'New Application has been created Successfully',
	addnewUser: 'New Users has been created Successfully',
	addAppFailure: 'Unable to create Application',
	errorCode101: '101',
	blobAlreadyExistsError:'BlobAlreadyExists',
	unabletoUpdateImageError:'Unable to Update Image',
	// Approval Queue
	noRecordsFound: 'No Records Found',
	approvalQueueTitle: 'Approval Queue Search',
	EmailNotExists:'Email Id does not exists',
	EmailNotExistsTitle:'Email not found', 
	// User Search
	userSearchTitle: 'User Search',
	EmailOTP:'Verification Code Sent Successfully',
	// Role Management
	roleCreationTitle: 'Role Creation',
	roleUpdateTitle: 'Role Updation',
	roleDeleteTitle: 'Role Deletion',

	roleCreateValidation: 'Please enter Role Name and Role Description',
	roleCreateRoleValidation: 'Role already exists',

	updateRoleSuccess: 'Application has been updated Successfully',
	updateRoleFailure: 'Unable to update Application',

	addRoleSuccess: 'New Role has been created Successfully',
	addRoleFailure: 'Unable to create Application',

	deleteRoleSuccess: 'Role is deleted Successfully',
	deleteRoleText: 'Are you sure you want to delete the Role',

	// Log Out
	logoutText: 'Are you sure you want to exit the Application',
	
	// Generic Role
	genericRoleDeleteTitle: 'Generic Role Deletion',
	deleteGenericRoleSuccess: 'Generic Role deleted Successfully',
	deleteGenericRoleText: 'Are you sure you want to delete the mapping for Position : ',

	// Generic Role Mapping
	genericRoleMappingTitle: 'Generic Role Mapping',
	genericRoleUpdateTitle: 'Generic Role Update',
	genericRoleMappingSuccess: 'Generic role assignment initiated. It will take few minutes to update for existing users',
	genericroleMappingFailed: 'Unable to assign generic role mapping to position',
	genericRoleMappingValidation: 'Please select the Roles and Position',
	genericRoleMappingChangeValidation: 'Please change the roles before submitting',

	// User App Role Mapping

	deleteUserRoleSuccess: 'Position Mapping with Application deleted Successfully	',
	deleteUserRoleText: 'Are you sure you want to delete the application mapping for Position : ',
	deleteMappingTitle: 'Delete Mapping',

	orgDeleteSuccess: 'Organization deleted Successfully',

	// User App Role Mapping Modal
	appRoleAssignTitle: 'Application and Roles',
	appRoleUpdateTitle: 'Application Assign Update',
	appRolePositionValidation: 'Please select position to continue',
	appRoleValidation: 'Please select the Roles and Application',
	approleAssignSuccess: 'Position application role assignment initiated. It will take few minutes to update for existing users',
	approleAssignFailed: 'Unable to update application role to position',

	userProfileAddAppRoleSuccess: 'Application and Roles added Successfully',
	userProfileEditAppRoleSuccess: 'Application and Roles updated Successfully',

	assignRoleSuccess: 'Application Roles assigned Successfully',
	assignRoleFailure: 'Unable to assign application role to position',
	assignRoleValidation: 'Please select the Roles and Application',

	// Generic Role Assign
	genericRoleAssignTitle: 'Generic Role Assign',
	genericRoleSuccess: 'Generic Roles is assigned Successfully',
	genericRoleFailure: 'Unable to assign Role',
	genericRoleValidation: 'Please select the Roles',

	// Change Password
	changePasswordTitle: 'Reset Password',
	changePasswordSuccess: 'Password Changed Successfully',
	changePasswordFailure: 'Unable to assign Role',
	newPasswordValidation: 'New Password cannot be empty',
	oldPasswordValidation: 'Old Password cannot be empty',
	confirmPasswordValidation: 'Confirm Password cannot be empty',
	samePasswordValidation: 'Old and New Password cannot be same',
	strongPasswordValidation: 'Please choose strong New Password',
	changePasswordMailText: 'Reset Password Notification has been sent to mail',

	//Audit History
	auditHistoryTitle: 'Audit History',

	//Update EmailId
	updateEmailTitle: 'Update Email Id',
	updateEmailSuccess: 'User Email Address Updated Successfully. Your session will be logged out in a couple of seconds.',
	updateEmailError: 'Unable to update Email',

	//Organisation/Sites
	addOrganizationTitle: 'Add Organization',
	addOrganizationSuccess: 'New Organization added successfully',
	changeOrganizationTitle: 'Change Organization',
	changeOrganizationSuccess: 'Change Organization processed successfully',
	orgMandatoryFieldError: 'Please select Mandatory fields',
	noOrgFoundMessage: 'No Organizations found for the selected country',


	// InActivate Account
	inactivateAccout: 'Are you sure you want to inactivate your account ?',

	// Application Roles
	deleteFailure: 'Unable to Delete',
	posMapAppRoleDeleteSuccess: 'Position Mapping with Application deleted Successfully',
	AppRoleDeleteSuccess: 'Application and Role mapping deleted Successfully',
	// Member Profile
	memberProfileTitle: 'Member Profile',
	memberProfileSuccess: 'Profile updated successfully',
	memberProfileFailure: 'Unable to update Profile',
	memberProfileBirthDtValidation: 'Birth Date cannot be future date',
	memberProfileMovDateValidation: 'Date Entered Movement cannot be future date',
	memberProfileEmailValidation: 'Email Already Exists',

	//Search Query Builder
	searchQueryTitle: 'Search Query',
	searchQueryOrgValidation: 'Please select Organization to choose Site',
	searchQueryParamValidation: 'Search parameter already exists',

	// User Registration
	userRegistrationTitle: 'User Registration',
	verifyEmail: 'Please verify Email to Register',
	registerFailure: 'Unable to Register User',

	// Board Registration
	boardRegistrationTitle: 'Board Registration',

	// Bulk User Registration
	bulkRegistrationTitle: 'Bulk User Registration',
	bulkRegSuccess: 'User Registration is in Progress... Notification will be sent once completed',
	bulkRegFailure: 'Error in Bulk Registration',

	// Delete Account
	deleteAccountTitle: 'Delete Account',
	deleteAccSuccess: 'User Deleted Successfully',
	deleteAccFailure: 'Unable to delete User',

	//Other Validations
	orgNoneAvailable: 'No Organizations found for the selected Country',
	onlyCSVExtensions: 'Only csv file extension is allowed',
	onlyFileExtensions: 'Only csv, xls, xlsx file extension is allowed',
	onlyOneFile: 'Only one file is allowed at a time',

	resetPasswordSuccess: 'Password has been reset successfully. \nPlease sign-in with your new password',
	allUserDisabledSuccess: 'All User disable request has been processed successfully.',
	passwordRules: `<ul> 
	<li>Password should at least 8 characters minimum.</li> 
	<li>Password should contains at least one upper and one lower case.</li>  
	<li>Password should contains at least one number and special character.</li>
	<li>Password is case sensitive.</li>
	</ul>`,

	affiliationRules: `
	<b> Q:		What is my BGCA affiliation? </b><br>
		<li> If you are employed at a Boys & Girls Club or Youth Center as a staff member or consultant, or if you serve as a board member of a Club or Youth Center, choose the Local Club affiliation. </li>
	 <li> If you do not work directly with Club members at a…. </li>
	 <li> Youth Center but oversee those centers at military headquarters level should choose the Military Command Staff affiliation. </li>
	 <li> Youth Center but oversee those facilities at Salvation Army headquarters, should choose the Salvation Army affiliation. </li>
	 <li> Alliance office or via a local Club lead agency, but work as a Board volunteer directly with their allied Clubs and organizations, should choose the BGCA Alliance affiliation. </li>
	 <li> Registrants who volunteer as a Board of Governor or Trustee for Boys & Girls Clubs of America -- the national headquarters -- should choose the Board of Governors affiliation. </li>
	 <br>
	 
	 <b> Q:	 	Why does BGCA need your ZIP code or state? </b><br>
			 <li>The ZIP code or state of your organization helps to determine your specific Club affiliation.</li>
	 <br>  
	 <b>  Q:	 	What is my organization? </b><br>
			 <li>Boys & Girls Clubs have an administrative office which manages the individual Club units. We are requesting the name of this office.</li>
	 <br>   
	 <b>  Q:	 	What Club(s) should I select? </b><br>
				<li>Select the Boys & Girls Club where you are employed.  Should you work at more than one Club, you may hold the control key down while selecting multiple options.</li>
	 <br>   
	 <b>  Q:	 	Why do you request personal information? </b><br>
	 A:<br>	 	<li>Contact information is requested from each registrant to facilitate communication, primarily through e-mail. The information requested will determine your affiliated Club, phone numbers and e-mail address.</li>
	 <br>   
	 <b>  Q:	 	What is my employee status? </b><br>
		 <li>For those employed at a Boys & Girls Club, select either the full-time or part-time designation.</li>
	 <br>   
	 <b>  Q:	 	What is my position type? </b><br>
		 <li>Club staff should choose the position that best reflects their job: CEO, unit directors, etc.
	 If you serve on a local Club's board, choose the Board Member designation. Consultants should choose the Contractor's option. Similarly, if a Club has requested you to register on BGCA.NET, but you are not employed by them, register as a Guest. If you have retired from the Boys & Girls Club Movement, but would like to stay involved, choose the Retiree designation.</li>

	 <li>Each registration is subject to approval by the CEO of the specified Boys & Girls Club.</li>`,

	dateMovementRules: `<b>Q:	Date Entered Movement </b><br>
	 <li>The first date you initially entered into a position within the Boys & Girls Club <br> Movement either at BGCA National Headquarters or at a local Club.</li>`,

	dummyPassword: 'Welcome@1',
	dummyPassword1: 'Welcome@2',
}


export class AppConstants {
	public static MUTATION = 'M0IxQzAwMjY5OTBFVIJLTRBNBGCAjQ5QjVDRDY0MDU2OTM0NzNDIAM';
}
